
    import Vue from 'vue';
    import { PropType } from 'vue';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    export default Vue.extend({
        components: {
            WhatsApp,
        },
        name: 'ModalCancel',
        props: {
            product: {
                type: String as PropType<string>,
                required: true,
            },
        },
        data() {
            return {
            }
        },
        methods: {
            getFilePath() {
                this.close();
                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                if (rutaAlternativa) {
                    this.$router.push(rutaAlternativa);
                }
                else {
                    this.$router.push(this.product);
                }
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },        
        },
        mounted() {
        },
    });
